if ('scrollPosition' in sessionStorage) {
  let target = sessionStorage.scrollPosition
  delete sessionStorage.scrollPosition

  let position = Number(target)
  if (isNaN(position) && typeof target === 'string') {
    let element = document.querySelector(target)

    if (element) {
      position = element.offsetTop - parseFloat(getComputedStyle(element).scrollMarginTop)
    }
  }
  if (position) {
    window.scrollTo({
      top: position,
      behavior: 'instant',
    })
  }
}

window.storeScrollPosition = function storeScrollPosition(target) {
  sessionStorage.scrollPosition = target ?? window.scrollY
}
